import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem/SliderListItem';

const BackdropVideoAccelerationIntensitySlider = (props) => {
    const { intensity, updateBackgroundSettings } = props;

    const onIntensityChange = useCallback((value) => {
        if (value === intensity) return;
        updateBackgroundSettings({ videoAcceleration: { intensity: value } });
    }, [intensity, updateBackgroundSettings]);

    return (
        <SliderListItem
            title='Intensity'
            displayMultiplier={1}
            value={intensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onIntensityChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { videoAcceleration } = state.createPreview.present.videoSettings.background;
    return {
        intensity: videoAcceleration?.intensity ?? 50
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropVideoAccelerationIntensitySlider);
